<template>
  <div style="width:100%;height: 100%">
    <div id="root">
      <div class="container edu-container" style="margin-top: 5vh; margin-bottom: 5vh;">
        <div class="row justify-content-center">
          <div class="col-12 col-md-7 col-lg-5 col-xl-5">
            <div class="text-center">
              <a  class="text-hide sf-logo d-inline-block">
                <img src="../../assets/img/logo.png" width="170" class="d-inline-block" alt="segmentfault"></a>
            </div>
            <div id="loginDiv" class="px-sm-5 mb-3 card border-0 mt-4">
              <div class="card-body">
                <h3 class="text-center my-3">绑定手机号</h3>
                <p class="text-center mb-4" style="color:#6C757D">为了你的账号安全，请绑定手机号</p>
                <div class="undefined">
                  <MobileLogin v-if="loginType == 'mobile'" :isBing="true"></MobileLogin>
                </div>
                <div class="text-muted text-center font-size-14 my-3">继续即代表同意<a
                    href="#" target="_blank">《服务协议》</a>和<a
                    href="#" target="_blank">《隐私政策》</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import MobileLogin from '@/components/MobileLogin.vue';
import WxCodeLogin from '@/components/WxCodeLogin.vue';
export default {
  name: "binding",
  data(){
    return {
      loginType:'mobile',
      checkClass:"mx-3 login-mode text-body",
      notClass:'mx-3 login-mode',
    };
  },
  methods:{
    clickLoginType(type)
    {
      this.loginType = type;
    }
  },
  computed:{},
  components:{
    MobileLogin,
    WxCodeLogin
  }
}

</script>
<style lang="scss" >
@import "../../assets/css/login.css";
</style>

